import {
  BrowserPrintNoPrinterError,
  BrowserPrintUnavailableError,
} from "./browserPrint"

/** Maps a print failure to the i18n key the clerk sees. */
export const printErrorMessageKey = (err: unknown) =>
  err instanceof BrowserPrintUnavailableError
    ? "printErrorUnavailable"
    : err instanceof BrowserPrintNoPrinterError
      ? "printErrorNoPrinter"
      : "printErrorFailed"
